import {
  GET_LOTTERY_DRAWS_REQUEST,
  GET_LOTTERY_DRAWS_SUCCESS,
  GET_LOTTERY_DRAWS_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOTTERY_DRAWS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_LOTTERY_DRAWS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_LOTTERY_DRAWS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
